import useCsrf from "lib/useCsrf";

import styles from "./SocialButton.module.css";

type PropTypes = {
  href: string;
  children: React.ReactNode;
};

const SocialButton: React.FC<PropTypes> = ({ href, children }) => {
  const csrf = useCsrf();

  return (
    <form action={href} method="post" className={styles.form}>
      <input type="hidden" name="authenticity_token" value={csrf} />
      <button type="submit" className={styles.socialButton}>
        {children}
      </button>
    </form>
  );
};

export default SocialButton;
